export const sessionStorageSave = <T>(key: string, data: T): void => {
  sessionStorage.setItem(key, JSON.stringify(data));
};

export const sessionStorageGet = <T>(key: string): T | null => {
  const data = sessionStorage.getItem(key);
  return data && JSON.parse(data);
};

export const sessionStorageRemove = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const sessionStorageListKeys = (): string[] => {
  const result: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key) {
      result.push(key);
    }
  }
  return result;
};
